(function($) {
	var body = null;
	var bottomBackgroundSizeOverlay = 0;
	var bottomBackgroundSize = 0;
	var databaseConfig = null;
	var isInIFrame = inIFrame();
	var errDialog;
	var interval = null;

	//setup url to send messsages back to parent
	var iframeParentLocation = istrobeUrl;

	var formatErrorMessage = function(message, type) {
		if (!message || message.toString().trim().length === 0) {
			if (type === 'test') {
				return dbTestErrorText;
			} else if (type === 'create') {
				return dbCreateErrorText;
			} else if (type === 'update') {
				return dbUpdateErrorText;
			} else if (type === 'read') {
				return dbReadErrorText;
			}
		} else {
			return message;
		}
	};

	var clearStatus = function() {
		if (!isInIFrame)
			$.clearStatus();
		else
			parent.postMessage(JSON.stringify({ code: 0 }), iframeParentLocation);
	};

	var showSuccessMessage = function(msg) {
		if (!isInIFrame)
			$.showSuccessStatus(msg);
		else
			parent.postMessage(JSON.stringify({ code: 2, message: msg }), iframeParentLocation);
	};

	var showCreateSuccessMessage = function(msg) {
		if (!isInIFrame) {
			$.showSuccessStatus(msg);
		} else {
			parent.postMessage(JSON.stringify({ code: 3, message: msg }), iframeParentLocation);
		}
	};

	var showErrorMessage = function(msg) {
		if (!isInIFrame)
			$.showErrorStatus(msg);
		else
			parent.postMessage(JSON.stringify({ code: 1, message: msg }), iframeParentLocation);
	};
	
	var encryptPasswords = function(params) {
		if(!!params.databaseDbaPassword)
		{
			var encrypted = Crypto.encrypt(params.databaseDbaPassword);
			params.a = encrypted.iv;
			params.b = encrypted.encrypted;
			delete params.databaseDbaPassword;
		}
		if(!!params.databaseAdminPassword)
		{
			var adminencrypted = Crypto.encrypt(params.databaseAdminPassword);
			params.c = adminencrypted.iv;
			params.d = adminencrypted.encrypted;
			delete params.databaseAdminPassword;
		}		
		if (!!params.sslKeystorePassword)
		{
			var keystorePwEncrypted = Crypto.encrypt(params.sslKeystorePassword);
			params.ssla = keystorePwEncrypted.iv;
			params.sslb = keystorePwEncrypted.encrypted;
			delete params.sslKeystorePassword;
		}
	}
	
	var addStoGroupAndBufferPools = function(params) {
		if (params.dbmsType === db2zos) {
			params.databaseStoGroup = $('#stoGroup').val().toUpperCase();				
			params.bufferpool4k = $('#bufferpool4k').val();
			params.bufferpool8k = $('#bufferpool8k').val();
			params.bufferpool16k = $('#bufferpool16k').val();
			params.bufferpool32k = $('#bufferpool32k').val();
		}
	}

	var migrateOpenCallback = function(params) {
		var databaseType = derbyName;
		
		var db2NoteText = '';
		let showMigrateDatabaseOption = true;
		
		if (params.dbmsType === db2luw) {
			databaseType = db2luwName;
		} else if (params.dbmsType === db2zos) {
			databaseType = db2zosName;
			db2NoteText = migrateDb2Note;
		} else if (params.dbmsType === sqlserver) {
			databaseType = sqlserverName;
			if ($('#useWindowsAuthToggle').is(':checked')) {
				showMigrateDatabaseOption = false;
			}
		} else if (params.dbmsType === oracle) {
			databaseType = oracleName;
		}
		
		$('#migrateDatabaseOption')[showMigrateDatabaseOption ? 'show' : 'hide']();
		$('#migrateDatabaseDialog .new-database-text').html(newDatabaseTextStart + ' ' + databaseType + ' ' + newDatabaseTextMiddle + ' ' + params.databaseName +  ' ' + newDatabaseTextEnd);

		var derbyDatabaseName = databaseConfig.options.dbParameters[dbName_property];
		var html = migrateDatabaseTextStart + ' ' + databaseType + ' ' + migrateDatabaseTextMiddle + ' ' + params.databaseName + ' ' + migrateDatabaseTextMiddleTwo + ' ' + derbyDatabaseName + migrateDatabaseTextEnd + db2NoteText;
		$('#migrateDatabaseDialog .migrate-database-text').html(html);
		$('#createRadioButton').attr('checked', 'checked');
		$('#migrateDatabaseDialog .new-database-icon').on('click', function(event) {
			$('#createRadioButton').attr('checked', 'checked');
		});

		$('#migrateDatabaseDialog .migrate-database-icon').on('click', function(event) {
			$('#migrateRadioButton').attr('checked', 'checked');
		});
	};

	var migrateOkCallback = function(params) {
		var migrate = $('#migrateRadioButton').is(':checked');
		var progressText = migratingText;

		if (!!migrate) {
			params.dbMigrate = true;
		} else {
		    progressText = creatingText;
		}
		
		saveConfiguration(params, progressText);
	};

	var migrateCloseCallback = function() {
		$('#migrateDatabaseDialog .new-database-text').html('');
		$('#migrateDatabaseDialog .migrate-database-text').html('');
		$('#migrateDatabaseDialog .new-database-icon').off('click');
		$('#migrateDatabaseDialog .migrate-database-icon').off('click');
	}

	var newOpenCallback = function(params) {
		var databaseType = derbyName;

		if (params.dbmsType === db2luw) {
			databaseType = db2luwName;
		} else if (params.dbmsType === db2zos) {
			databaseType = db2zosName;
		} else if (params.dbmsType === sqlserver) {
			databaseType = sqlserverName;
		} else if (params.dbmsType === oracle) {
			databaseType = oracleName;
		}

		$('#newDatabaseDialog .new-database-text').html(newDatabaseTextStart + ' ' + databaseType + ' ' + newDatabaseTextMiddle + ' ' + params.databaseName + ' ' + newDatabaseTextEnd);
	};

	var newOkCallback = function(params) {
		saveConfiguration(params, creatingText);
	};

	var newCloseCallback = function() {
		$('#newDatabaseDialog .new-database-text').html('');
	};

	var upgradeOpenCallback = function(params) {
		var databaseType = upgradeDatabaseTextStartAn + ' ' + derbyName;
		
		if (params.dbmsType === db2luw) {
			databaseType = upgradeDatabaseTextStartAn + ' ' + db2luwName;
	 	} else if (params.dbmsType === db2zos) {
	 			databaseType = upgradeDatabaseTextStartAn + ' ' + db2zosName;
	 	} else if (params.dbmsType === sqlserver) {
	 			databaseType = upgradeDatabaseTextStartA + ' ' + sqlserverName;
	 	} else if (params.dbmsType === oracle) {
	 			databaseType = upgradeDatabaseTextStartAn + ' ' + oracleName;
	 	}
		
		$('#upgradeDatabaseDialog .upgrade-database-text').html(databaseType + ' ' + upgradeDatabaseTextMiddle + ' ' + params.databaseName + ' ' + upgradeDatabaseTextEnd);
	};

	var upgradeOkCallback = function(params) {
		params.dbUpgrade = true;
		saveConfiguration(params, upgradingText);
	};

	var upgradeCloseCallback = function(dialogID) {
		$('#upgradeDatabaseDialog .upgrade-database-text').html('');
	};
	
	var upgradeNobufferOpenCallback = function(params) {
		var databaseType = upgradeNobufferDatabaseTextStartAn + ' ' + derbyName;
		
		if (params.dbmsType === db2luw) {
			databaseType = upgradeNobufferDatabaseTextStartAn + ' ' + db2luwName;
	 	} else if (params.dbmsType === db2zos) {
	 		databaseType = upgradeNobufferDatabaseTextStartAn + ' ' + db2zosName;
	 	} else if (params.dbmsType === sqlserver) {
	 		databaseType = upgradeNobufferDatabaseTextStartA + ' ' + sqlserverName;
	 	} else if (params.dbmsType === oracle) {
	 		databaseType = upgradeNobufferDatabaseTextStartAn + ' ' + oracleName;
	 	}

		$('#upgradeNobufferDatabaseDialog .upgrade-nobuffer-database-text').html(databaseType + ' ' + upgradeNobufferDatabaseTextMiddle + ' ' + params.databaseName + ' ' + upgradeNobufferDatabaseTextEnd);
	};

	var upgradeNobufferOkCallback = function(params) {
		params.dbUpgrade = true;
		saveConfiguration(params, upgradingText);
	};

	var upgradeNobufferCloseCallback = function(dialogID) {
		$('#upgradeNobufferDatabaseDialog .upgrade-nobuffer-database-text').html('');
	};

	var switchOpenCallback = function(params) {
		var databaseType = switchDatabaseTextStartAn + ' ' + derbyName;

		if (params.dbmsType === db2luw) {
			databaseType = switchDatabaseTextStartAn + ' ' + db2luwName;
		} else if (params.dbmsType === db2zos) {
			databaseType = switchDatabaseTextStartAn + ' ' + db2zosName;
		} else if (params.dbmsType === sqlserver) {
			databaseType = switchDatabaseTextStartA + ' ' + sqlserverName;
		} else if (params.dbmsType === oracle) {
			databaseType = switchDatabaseTextStartAn + ' ' + oracleName;
		}

		$('#switchDatabaseDialog .switch-database-text').html(databaseType + ' ' + switchDatabaseTextMiddle + ' ' + params.databaseName + ' ' + switchDatabaseTextEnd);
	};

	var switchOkCallback = function(params) {
		saveConfiguration(params, switchingText);
	};

	var switchCloseCallback = function(dialogID) {
		$('#switchDatabaseDialog .switch-database-text').html('');
	};

	var showDatabaseCreateDialog = function(dialogID, params, openCallback, okCallback, closeCallback, source) {	
		encryptPasswords(params);
		$.post('database/test', params).always(function(dbConnect) {
			if (!!dbConnect) {
				var dbJson = $.parseJSON(dbConnect);
				
				if (!!dbJson && typeof dbJson.majorVersion !== "undefined") {
					var majorVer = parseInt(dbJson.majorVersion);
					var bufferPoolsNeeded = dbJson.bufferpools;
					var message = dbJson.message;
				}
			}
				
			if (params.dbmsType === db2zos && !!message) {
				if (message.includes('User ID or Password invalid')) {
					$.showErrorStatus(db2_user_pass_invalid);
				} else {
					$.showErrorStatus(message);
				}
			}		
			else
			{
				var dbCutoff = 375;//18.2.2 and above we want to ask for bufferpools before generating ddl
				var generateDDL = '#generateDDLDialog';
				var generatingDDL = dialogID === generateDDL && majorVer !== -1 && !bufferPoolsNeeded && params.dbmsType === db2zos;
				
				if (generatingDDL && (typeof okCallback === 'function')) {
					okCallback.call(this, params);
				} else if (!!dialogID) {
					displayDialog(dialogID, params, openCallback, okCallback, closeCallback, source, bufferPoolsNeeded);
				}
			}
		});
	};
	
	function displayDialog(dialogID, params, openCallback, okCallback, closeCallback, source, bufferPoolsNeeded)
	{
		$(dialogID).dialog({
			title: databaseSettingsTitle,
			autoOpen: true,
			modal: true,
			width: 400,
            draggable : false,
            resizable : false,
			buttons : [{
				text: okButtonText,
				id: "db-ok-button",
				click: function() {
					if (params.dbmsType !== db2zos || $('#bufferPoolsForm').valid()) {
						addStoGroupAndBufferPools(params);
						
                        $.animateCloseDialog(dialogID, source);

						if (typeof okCallback === 'function') {
							okCallback.call(this, params);
						}
					}
				}
			}, {
				text: cancelButtonText,
				click: function() {
				    $.animateCloseDialog(dialogID, source);
				    resetHandler();
				}
			}],	
			open: function(event, ui) {
			
				$('#db-ok-button').prop('disabled', false);
				
				// Attach the bufferpool/stogroup parameters
				if ((params.dbmsType === db2zos && dialogID !== '#switchDatabaseDialog') && bufferPoolsNeeded ) {
					$(dialogID).append($('#bufferPoolsDialog').detach());
					$('#bufferPoolsForm').on('click', function(event){event.stopPropagation();});
					$('.ui-dialog-buttonset button').on('click', function(event){event.stopPropagation();});
					if(!$('#bufferPoolsForm').valid()){
						$('#db-ok-button').attr('disabled', 'disabled');
					}
				}
				
				$.animateOpenDialog(dialogID, source);
			    if (typeof openCallback === 'function') {
					openCallback.call(this, params);
				}

				var dialog = $(this).parent();

				dialog.offset({
					top: (window.innerHeight / 2) - (dialog.height() / 2),
					left: (window.innerWidth / 2) - (dialog.width() / 2)
				});                            
			},
			close: function(event, ui) {
				if (typeof closeCallback === 'function') {
					closeCallback.call(this);
				}

				if (params.dbmsType === db2zos && dialogID !== '#switchDatabaseDialog' &&
						dialogID !== '#upgradeDatabaseDialog') {
					$('#bufferPoolsContainer').append($('#bufferPoolsDialog').detach());
				}
				
				databaseConfig.enableAllFields();                        
			}
		});
	}

	var genDDLOkCallback = function(params) {
		saveDDLScriptsHandler(params);
	};
	
	var genDDLCreateOkCallback = function(params) {
		saveDDLCreationScriptsHandler(params);
	};
	
	var isFormPopulated = function() {
	    var formData = $('#dbConfigForm .form-contents *').not('select').serializeArray();
	    var formPopulated = formData.some(function(item) {
	        var value = item['value'];
	        return (!!value && value.trim().length > 0);
	    });

	    return formPopulated;
	};
	
	var genDDLScriptsHandler = function(data) {
		if (data.dbmsType !== db2zos) {
			saveDDLScriptsHandler(data);
		} else {			
			if (!isFormPopulated()) {
				displayDialog('#generateDDLDialog', data, null, genDDLCreateOkCallback, null, '#SaveDDLScripts', true);
			} else if ($('#dbConfigForm').valid()) {
				showDatabaseCreateDialog('#generateDDLDialog', data, null, genDDLOkCallback, null, '#SaveDDLScripts');
			}
		}
	};
	
	var saveDDLScriptsHandler = function(data) {
		//TODO: write code to make the ajax call to download the DDL scripts
		$.displayLoadingIndicator(downloadingText);

		// Encode User password for credentials
		encryptPasswords(data);
		
		$.fileDownload('database/downloadDDLScripts', {data : data}).fail(function(json) {
			$.showErrorStatus(JSON.parse(json).message);
		}).always(function() {
			$.removeLoadingIndicator();
		});	
	};
	
	var saveDDLCreationScriptsHandler = function(data) {
		//TODO: write code to make the ajax call to download the DDL scripts
		$.displayLoadingIndicator(downloadingText);

		// Encode User password for credentials
		encryptPasswords(data);
				
		$.fileDownload('database/downloadDDLCreationScripts', {data : data}).fail(function(json) {
			$.showErrorStatus(JSON.parse(json).message);
		}).always(function() {
			$.removeLoadingIndicator();
		});
	};

	var resetHandler = function() {
		// nothing to do
	};

	var applyConnection = function(testResult, params) {
		if (testResult === null || params === null) {
			return;
		}
		
		// Determine if configuration changed
		var dbPreviouslyConfigured = !!databaseConfig.options.dbParameters[dbName_property];
		// DataChanged doesn't check credentials, only server, port, etc.
		var configurationNotChanged = dbPreviouslyConfigured && !databaseConfig.dataChanged();

		//if database already configured and only credentials got changed
		if (testResult.toUpperCase() === 'EQUAL' && configurationNotChanged) {
			//then only save the changed credentials 
			saveConfiguration(params);
		} else {
			if (testResult.toUpperCase() === 'DNE') {
				if (databaseConfig.options.dbParameters[dbmsType_property] === derby){
                    if (params.dbmsType === db2zos && ($('#sslConnect').is(':checked') || params.db2Security !== 'standard') || $('#dbSelect').val() === 'smfarchdb') {
						showDatabaseCreateDialog('#newDatabaseDialog', params, newOpenCallback, newOkCallback, newCloseCallback, '#apply');
					}else{
						//display the new/migrate database dialog
						showDatabaseCreateDialog('#migrateDatabaseDialog', params, migrateOpenCallback, migrateOkCallback, migrateCloseCallback, '#apply');
					}		
				} else {
					//display the new database dialog
					showDatabaseCreateDialog('#newDatabaseDialog', params, newOpenCallback, newOkCallback, newCloseCallback, '#apply');
				}
			} else if (testResult.toUpperCase() === 'UPGRADE') {
				//display the upgrade database dialog
				showDatabaseCreateDialog('#upgradeDatabaseDialog', params, upgradeOpenCallback, upgradeOkCallback, upgradeCloseCallback, '#apply');
			} else if (testResult.toUpperCase() === 'EQUAL' && 
				databaseConfig.options.dbParameters[dbmsType_property] === derby &&
				params.dbmsType === derby) {
				//skip dialog and go right to success message
				configNotChanged(configurationSaved);
			} else {
				//display the switch database dialog				
				showDatabaseCreateDialog('#switchDatabaseDialog', params, switchOpenCallback, switchOkCallback, switchCloseCallback, '#apply');
			}
		}
	};
	
	// called if user 'switches' from derby to derby, and version is not changed.
	function configNotChanged(message) {
		showSuccessMessage(message);
		resetHandler();
		databaseConfig.enableAllFields();
	}
	
	// function for the apply button
	function saveConfiguration(params, progressText) {
	    if (!progressText) {
	        progressText = processingText;
	    }
	    
	    if (!params.dbUpgrade){
			$.displayLoadingIndicator(progressText);
	    }
	    else{
    		$.displayProgressBar(progressTitle, progressText);
    		interval = setInterval(function(){
  			var progress = $.getJSON('database/getPercentDone',
   					{
   						nocache: new Date().getTime()
   					}
   				);

    			progress.done(function(data){
    				if (data.success == true){
    					$.updateProgressBar(data.percentDone);
    				}
    			});
    		}, 1000);
	    }
		// Encode User password for credentials
	    encryptPasswords(params);

		var delegateURL = 'database/switchDB';

		if ($('#dbSelect').val() === 'smfarchdb') {
			delegateURL = 'database/createDB';
		}

		$.post(delegateURL, params, function(result) {
			
			if (result.success === 'true') {
			    if (!!result.dbStatus && result.dbStatus === 'pending') {
			        $.showMessageDialog({
			            title : pendingTitle,
			            width: 650,
			            message : result.message
			        });
			    } else if (!!result.dbStatus && result.dbStatus === 'grantsFailed') {
			    	$(window).trigger('grantsFailed', [result.grantsFileLocation, result.grantsErrorDetails, result.sqlExecuted]);
			    } else {
			        showCreateSuccessMessage(result.message);
			    }
			    
				databaseConfigured = true;
			} else {
				showErrorPopUp(result.message, result.SQL, result.info, params);
				$('.form-contents input').removeAttr('disabled');
				$('.form-contents select').removeAttr('disabled');
			}
		}, 'json' ).always(function(result) {
			databaseConfig.enableAllFields();
			// update ui based on SQL Server Windows Auth toggle if applicable
			useWindowsAuthHandler();
			if (!result.dbStatus || (!!result.dbStatus && result.dbStatus !== 'pending')) {
				rereadData();
			}			
			$.removeLoadingIndicator();
			clearInterval(interval);
			
			// Log user out if temp user and upgrade complete
			if (user == recoveryUser) {
				window.location.href = '/compuware/logout';
			}
			
		});
	};

	var showErrorPopUp = function(errMessage, sql, info, params) {
		var dialogwidth = 650;
		var resizable = false;
	
		if (params.dbUpgrade == true && params.dbmsType == 'ibmDB2zOS' && errMessage.includes("Bufferpools and Stogroup")) {
			showDatabaseCreateDialog('#upgradeNobufferDatabaseDialog', params, upgradeNobufferOpenCallback, 
				upgradeNobufferOkCallback, upgradeNobufferCloseCallback, '#apply');
		}

		else {
	        //Check line widths
	        if(!!sql && sql.length > 1200) {
	                resizable = true;
	        } else if(!!errMessage && errMessage.length > 1200) {
	                resizable = true;
	        }
	
			//Show appropriate dialog
			if (!!info && !!errMessage){
				$('#error-info-text').text(info);       
			}
	
			if (!!sql) {
				//format the sql
				$('#sqlHeader').show();
				$('#sqlText').show();
				$('#errorMessageText').text(errMessage);
				$('#sqlText').val(sql);
				$('#sqlText').format({method:'sql'});
			} else if (!!errMessage) {
				$('#errorMessageText').text(errMessage);
			} else {
				//unknown error occurred! must be on the backend!
				$('#errorMessageText').text('An unknown error occurred');
			}
			
	        // Set dialog title if informational, not actual error
	        var dialogTitle = databaseErrorTitle;
	        if(errMessage ===  copycheck) {
	        	dialogTitle = copycheckTitle;
	        	$('.error-section-title').html('');
	        } 
	
			//initialize the dialog if not already initialized
			if (!errDialog) {
				errDialog = $('#sqlErrorMsgDialog').dialog({
					title: dialogTitle,
					autoOpen: false,
					modal: true,
					width: dialogwidth,
					draggable : false,
					resizable: resizable,
					buttons : [{
						text: "OK",
						click: function() {
							$(this).dialog("close");
						}
					}],
					close: function(event, ui) {
						//Clear junk
						$('#errorMessageText').text('');
						$('#sqlText').val('');
						$('#sqlHeader').hide();
						$('#sqlText').hide();
						$(this).dialog('close');
					}
				});
			}
	
			errDialog.dialog('open');
			}
	}

	var testAndApplyHandler = function(params) {
		$.when(
			testConnection(params, databaseConfig)
		).then(function(testResult){
			if(!!testResult && !testResult.message) {
				applyConnection(testResult.version, params);
			}
		});
	};


	// function for the test connection button
	function testConnection(params, formConfig) {		
		$.displayLoadingIndicator(testingText);
		
		encryptPasswords(params);
		
		return $.post('database/test', params, function(result) {
			if (!result.message) {
				formConfig.disableAllFields();
			} else {
				showErrorMessage(formatErrorMessage(result.message, 'test'));
			}
		}, 'json').always(function() {
			$.removeLoadingIndicator();
		});
	};

	// Re-read the database configuration after posting a change to update internal data
	var rereadData = function() {
		$.getJSON('database/list', 
				{
					requestType: 'list',
					dbSelect: $('input[name="dbSelect"]:checked').val(),
					nocache: new Date().getTime()
				},
				function(data) {
					dbParameters = data;
					databaseConfig.updateData(data);
				}
		);
	};
	
	var useWindowsAuthHandler = function() {
		if(isWindows) {
			if ($('#useWindowsAuthToggle').is(':checked')) {
				$('.access').prop('disabled', 'disabled');
				$('.access').removeClass('error errorborder');
			} else {
				$('.access').removeAttr('disabled');
			}
		}
	};

	$(document).ready(function() {
		if (isInIFrame) {
			$(document.body).addClass("in-iframe");
		}

		var dbConfigForm = $('#dbConfigForm');  
		
        //polyfil for placeholder tag in IE 9
        $('input, textarea').placeholder();

		// Get the current database configuration
		$.getJSON('database/list', {
			requestType: 'list', 
			dbSelect: dbSelect,
			nocache: new Date().getTime()
		}, function(data) {
			// Did we get a successful return?
			if (data.success) {
				dbParameters = data;
				$('#stoGroup').val(data['dbCreate.db2.stogroup']);
				$('#bufferpool4k').val(data['dbCreate.db2.bp4k']);
				$('#bufferpool8k').val(data['dbCreate.db2.bp8k']);
				$('#bufferpool16k').val(data['dbCreate.db2.bp16k']);
				$('#bufferpool32k').val(data['dbCreate.db2.bp32k']);
				
				// Create an instance of the database configuration component
				databaseConfig = dbConfigForm.databaseConfig({
					saveDDLScriptsHandler: genDDLScriptsHandler,
					testAndApplyHandler: testAndApplyHandler,
					resetHandler: resetHandler,
					dbParameters: data,
					dbSelect: dbSelect,
					clearStatus: clearStatus,
					showError: showErrorMessage
				});
			} else {
				// Display the error message
				showErrorMessage(formatErrorMessage(data.message, 'read'));
			}
			
		});

		$('.config-form').on('click', function(event){event.stopPropagation();});
		$("html").on("click", function(){$.clearStatus();});
		if(isWindows) {
			$('#useWindowsAuthToggle').on('click', useWindowsAuthHandler);
		}
		
		dbConfigForm.fadeIn(125);
	});
})(jQuery);